import { render, staticRenderFns } from "./TopicRow.vue?vue&type=template&id=39997caf&"
import script from "./TopicRow.vue?vue&type=script&lang=js&"
export * from "./TopicRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports